import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@vltansky/ng-select';
import { BllSelectComponent } from './select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BllHintModule } from '../hint';
import { BllTooltipModule } from '../tooltip';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, BllHintModule, BllTooltipModule],
  declarations: [BllSelectComponent],
  exports: [BllSelectComponent],
})
export class BllSelectModule {}
